import { render, staticRenderFns } from "./RoleAccessField.vue?vue&type=template&id=ff41052e&"
import script from "./RoleAccessField.vue?vue&type=script&lang=js&"
export * from "./RoleAccessField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports